import { render, staticRenderFns } from "./ServiceTypeCards.vue?vue&type=template&id=602c56d9&"
import script from "./ServiceTypeCards.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports